import { UAParser } from 'ua-parser-js'

export const checkIsMobile = () => {
  const parser = new UAParser()
  return parser.getDevice().type === 'mobile'
}
